export default {
  estimatedPrice: 'Approximate order price (for 1 mix)',
  submitForm: 'Fill out the contact form',
  goToSummary: 'Go to summary',
  modify: 'modify',
  quantity: 'pcs / package',
  attach: 'Attach a file',
  chosenTastes: 'Chosen flavors',
  chosenCategory: 'Chosen product',
  heading: 'Order summary',
  customHeading: 'Not standard Order',
  subheading: 'Check if everything is correct',
  chosenBonuses: 'Chosen add-ons',
  comment: 'Additional comment',
  infoDesc: 'Give us the amount of volume you plan to repack and we will prepare a special offer for you.',
  noExtra: 'No add-ons',
};
